export default "__VITE_PUBLIC_ASSET__4582f7b9__"